import { render, staticRenderFns } from "./personalIndex.vue?vue&type=template&id=458a2cb8&scoped=true&"
import script from "./personalIndex.vue?vue&type=script&lang=js&"
export * from "./personalIndex.vue?vue&type=script&lang=js&"
import style0 from "./personalIndex.vue?vue&type=style&index=0&id=458a2cb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458a2cb8",
  null
  
)

export default component.exports